<template>
  <div class="" :id="this.$route.name">
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">{{ title }}</h4>
        <hr />
      </template>
      <template v-slot:content>
        <form @submit.prevent="this.$ValidForm(this)" autocomplete="off">
          <tab :tab="Tablist">
            <template v-slot:content0>
              <div class="container mt-3 mb-3">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <small>نام شعبه</small>
                    <input @keypress="$ValidPersian($event, 20)" type="text" id="NameShobe" class="form-control InputText required" v-model="DataAxios.NameShobe" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>کد شعبه</small>
                    <input @keypress="$ValidNumber($event, 3)" type="text" id="CodeShobe" class="form-control InputText required ValidCodeShobe" style="direction: ltr" v-model="DataAxios.CodeShobe" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>شماره شعبه</small>
                    <input @keypress="$ValidNumber($event, 3)" id="shomareShobe" class="form-control Input required ValidshomareShobe" style="direction: ltr" v-model.number="DataAxios.ShomareShobe" type="number" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-6 col-12">
                    <small>تلفن</small>
                    <input @keypress="$ValidNumber($event, 8)" type="number" id="tel" class="form-control InputText" style="direction: ltr" v-model="DataAxios.Tel" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>نمابر</small>
                    <input @keypress="$ValidNumber($event, 11)" type="number" id="fax" class="form-control InputText ValidNamabar" style="direction: ltr" v-model="DataAxios.Fax" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>کد پستی</small>
                    <input @keypress="$ValidNumber($event, 10)" type="number" id="codePosti" class="form-control InputText" style="direction: ltr" v-model="DataAxios.CodePosti" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-3 col-12">
                    <small>شناسه ملی</small>
                    <input @keypress="$ValidNumber($event, 15)" type="number" id="shenaseMeli" class="form-control InputText ValidShenaseMeli" style="direction: ltr" v-model="DataAxios.ShenaseMeli" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>کد اقتصادی</small>
                    <input @keypress="$ValidNumber($event, 15)" type="number" id="shenaseMeli" class="form-control InputText ValidShenaseMeli" style="direction: ltr" v-model="DataAxios.ShenaseEghtesadi" />
                  </div>
                  <div class="col-lg-3 col-12">
                    <small>شماره ثبت</small>
                    <input type="text" @keypress="$ValidNumber($event, 10)" id="sabtNo" class="form-control InputText ValidShomareSabt" style="direction: ltr" v-model="DataAxios.SabtNo" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-12 col-12">
                    <small>آدرس</small>
                    <textarea @keypress="$ValidPersian($event, 150)" rows="3" type="text" id="adres" class="form-control InputText" v-model="DataAxios.Adres"></textarea>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-lg-5 col-12">
                    <small>نام لاتین</small>
                    <input type="text" @keypress="$Validengilsh($event, 50)" id="nameLatinShobe" class="form-control text-left InputText" style="direction: ltr" v-model="DataAxios.NameLatinShobe" />
                  </div>
                  <div class="col-lg-4 col-12">
                    <small>تاریخ تاسیس</small>
                    <date-picker v-model="DataAxios.TarixTasis" :editable="true" color="#ff9800"></date-picker>
                    <input type="text" id="tarixTasis" class="d-none InputText" tabindex="-1" style="direction: ltr" v-model="DataAxios.TarixTasis" />
                  </div>

                  <div class="col-lg-3 col-12">
                    <small>ارسال پیامک</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input InputText" id="isSmsactive" v-model="DataAxios.IsSmsactive" />
                        <label class="custom-control-label" for="isSmsactive">ارسال پیامک</label>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:content1>
              <div class="container">
                <div class="row">
                  <div class="col-md-5 col-12">
                    <Imguploader :Options="LogoOPtions"></Imguploader>
                  </div>
                  <div class="col-md-1"></div>
                  <div class="col-md-5 col-12">
                    <!-- <Imguploader :Options="EmzaOPtions"></Imguploader> -->
                  </div>
                </div>
              </div>
            </template>
            <!-- <template v-slot:content1 >
                            آپلود لوگو
                        </template>
                        <template v-slot:content2 >
                            <div class="container mt-3 mb-3">
                                 <div class="row">
                                    <div class="col-lg-4 col-12">
                                        <small>اعتبار کلمه عبور ( روز )</small>
                                        <input type="number" @keypress="$ValidNumber($event, 9)" id="etebarPasswordBeroz" class="form-control InputText" style="direction: ltr" v-model="DataAxios.EtebarPasswordBeroz"/>
                                    </div>
                                    <div class="col-lg-4 col-12">
                                        <small>زمان غیرفعال بودن کاربر ( دقیقه )</small>
                                        <input type="number" @keypress="$ValidNumber($event, 2)" id="userTimeOut" class="form-control InputText" style="direction: ltr" v-model="DataAxios.UserTimeOut"/>
                                    </div>
                                    <div class="col-lg-4 col-12">
                                        <small>تعداد مجاز ورود نا موفق</small>
                                        <input type="text" @keypress="$Validengilsh($event, 2)" id="howManyVerify" class="form-control InputText" style="direction: ltr" v-model="DataAxios.HowManyVerify"/>
                                    </div>
                                </div>
                            </div>
                        </template> -->
          </tab>
          <btn-save-data v-if="$route.params.Status == 'Add'" @Success="AddSuccess" :DataParanet="DataAxios"></btn-save-data>
          <btn-edit-data v-if="$route.params.Status == 'Edit'" :DataParanet="DataAxios"></btn-edit-data>
        </form>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '../../components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

import BtnEditData from '@/components/BnpButtons/BtnEditData.vue'
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue'
import Imguploader from '@/components/Uploader/Imguploader.vue'

export default {
  data() {
    return {
      LogoOPtions: {
        id: 'LogoUploader',
        tblAttachments: {
          Id: 10,
          Filename: '',
          Filepath: '',
          Binary: null,
          TableName: 'TblShobe',
          MasterId: this.$route.params.DataRow.Id,
          ParentFormId: '',
          Dbname: 'BnpCRM',
          ZamanInsert: '',
          TblUserGrpIdInsert: 10,
          TblUserGrpIdLastEdit: null,
          ZamanLastEdit: '',
        },
        SaveFolder: 'TblShobe',
      },
      EmzaOPtions: {
        id: 'EmzaUoploader',
        tblAttachments: {
          Id: 10,
          Filename: '',
          Filepath: '',
          Binary: null,
          TableName: '',
          MasterId: this.$route.params.DataRow.Id,
          ParentFormId: '',
          Dbname: 'BnpCRM',
          ZamanInsert: '',
          TblUserGrpIdInsert: 10,
          TblUserGrpIdLastEdit: null,
          ZamanLastEdit: '',
        },
        SaveFolder: 'TblShobe',
      },

      // Tablist:[{ header: 'اطلاعات سازمان'},{ header: 'لوگــو'},{ header: 'متفرقه'}],
      Tablist: [{ header: 'اطلاعات سازمان' }, { header: 'بارگذاری تصاویر' }],
      title: '',
      DataAxios: {},
    }
  },
  components: { Card, Tab, datePicker: VuePersianDatetimePicker, BtnSaveData, BtnEditData, Imguploader },
  created() {
    if (this.$route.params.Status) {
      if (this.$route.params.Status == 'Add') {
        if (this.$session.get(this.$route.name.substring(6))[0].isMojaz == 1) {
          this.title = 'افـزودن سازمان'
        }
      } else {
        this.title = 'ویـرایـش سازمان'
        this.GetImages(this.$route.params.DataRow.Id)
        console.log(this.$route.params)
      }
    } else {
      this.$router.push({ name: this.$route.name.substring(6) })
    }
  },
  mounted() {
    if (this.$route.params.Status == 'Edit') {
      this.DataAxios = this.$route.params.DataRow
      this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
    }
  },
  methods: {
    AddSuccess(result) {
      if (result == true) {
        this.DataAxios = []
      }
    },
    GetImages(Id) {
      var dataaxios = { Method: 'POST', Action: 'CrmFile/GetFileByMasterId', ArryfildValue: { Id: Id } }
      this.$PostData(dataaxios).then((result) => {
        if (result.data != null) {
          this.LogoOPtions.tblAttachments = result.data
        }
      })
    },
  },
}
</script>
<style scoped></style>
